import React from 'react';
import { Grid, TextField } from '@material-ui/core';
import { OptionListType } from '@sierralabs/forms-core';
import { useFormContext } from '../FormContext';
import FormConfigOptions from './FormConfigOptions';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
export const FormConfigSelect = () => {
    var _a;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = { type: OptionListType.List };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(TextField, { fullWidth: true, variant: 'outlined', label: 'Placeholder', value: ((_a = element.config) === null || _a === void 0 ? void 0 : _a.placeholder) || '', onChange: event => {
                    element.config.placeholder = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(FormConfigOptions, null)));
};
export default FormConfigSelect;
//# sourceMappingURL=FormConfigSelect.js.map